import React, { useState } from 'react';
import { LucideIcon } from 'lucide-react';
import StatCard from './StatBox';

export type Stat = {
  label: string;
  value: string | number;
  icon: LucideIcon;
  gradient?: string;
  iconBg?: string;
  iconColor?: string;
  info?: string;
};

export interface StatSectionProps {
  title: string;
  icon: React.ElementType;
  stats: Stat[];
}

export const StatSection: React.FC<StatSectionProps> = ({ title, icon: Icon, stats }) => {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? stats : stats.slice(0, 3);

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon className="w-4 h-4" style={{ color: '#464554B2' }} />
          <span className="text-xs font-bold tracking-widest uppercase" style={{ color: '#464554B2' }}>{title}</span>
        </div>
        {stats.length > 3 && (
          <button
            onClick={() => setExpanded(v => !v)}
            className="flex items-center gap-1 text-xs font-semibold text-indigo-500 hover:text-indigo-700 transition-colors"
          >
            {expanded ? 'Show Less' : 'Show More'}
            <svg
              className={`w-3.5 h-3.5 transition-transform duration-200 ${expanded ? 'rotate-180' : ''}`}
              fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        )}
      </div>

      <div className="grid grid-cols-3 gap-3">
        {visible.map((stat, i) => (
          <StatCard key={i} label={stat.label} value={stat.value} icon={stat.icon} iconBg={stat.iconBg} iconColor={stat.iconColor} info={stat.info} />
        ))}
      </div>
    </div>
  );
};

export default StatSection;
